export default class ViewSimpleFileVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	defaultValue = '';
	name = "Simple file";
	fieldType = 'simpleFile';
	uiComponent = 'view-simple-file-field';
	description = 'A simple upload of a single file';

	constructor()
	{
		
	}
}